import * as am4charts from "@amcharts/amcharts4/charts";

import * as am4core from "@amcharts/amcharts4/core";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import CircularProgress from "@material-ui/core/es/CircularProgress/CircularProgress";
import React, {Component} from "react";
import * as API from "../util/api";
import * as Render from "../util/Render";

am4core.useTheme(am4themes_animated);


export default class PopupStatsGraph extends Component {

    constructor() {
        super();
        this.graphRef = React.createRef();
        this.state = {loaded: false};
    }

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(oldProps, n, p) {
        if (oldProps.camera_id != this.props.camera_id) {

        }
    };

    load = () => {
        API.POST("log/getUsageData", {sensor_id: this.props.camera_id}, result => {
            if (result.success) {
                this.setState(result.result, this.loadGraph);
            }
        });
    };

    loadGraph = () => {
        am4core.options.commercialLicense = true;
        let chart = am4core.create(this.graphRef.current, am4charts.XYChart);

        chart.paddingRight = 20;
        chart.colors.list = [
            am4core.color("#ff0000"),
            am4core.color("#00ff00"),
            am4core.color("#0000ff")
        ];

        let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
        dateAxis.renderer.grid.template.location = 0;

        dateAxis.dateFormats.setKey("hour", "dd MMM HH:mm");
        dateAxis.periodChangeDateFormats.setKey("hour", "dd MMM HH:mm");
        dateAxis.dateFormats.setKey("minute", "dd MMM HH:mm");
        dateAxis.periodChangeDateFormats.setKey("minute", "dd MMM HH:mm");
        dateAxis.dateFormats.setKey("day", "dd MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("day", "dd MMM yyyy");
        dateAxis.dateFormats.setKey("week", "dd MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("week", "dd MMM yyyy");
        dateAxis.dateFormats.setKey("month", "MMM yyyy");
        dateAxis.periodChangeDateFormats.setKey("month", "MMM yyyy");

        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.tooltip.disabled = true;

        let series = chart.series.push(new am4charts.LineSeries());
        series.dataFields.dateX = "date";
        series.dataFields.valueY = "community";
        series.name = "Community Viewer";
        series.tooltipText = "{valueY.value} community app loads";

        let series2 = chart.series.push(new am4charts.LineSeries());
        series2.dataFields.dateX = "date";
        series2.dataFields.valueY = "system";
        series2.name = "System Viewer";
        series2.tooltipText = "{valueY.value} system viewer loads";

        let series3 = chart.series.push(new am4charts.LineSeries());
        series3.dataFields.dateX = "date";
        series3.dataFields.valueY = "web";
        series3.name = "Web Portal";
        series3.tooltipText = "{valueY.value} web portal loads";

        chart.cursor = new am4charts.XYCursor();

        let scrollbarX = new am4charts.XYChartScrollbar();
        scrollbarX.series.push(series);
        scrollbarX.series.push(series2);
        scrollbarX.series.push(series3);
        chart.scrollbarX = scrollbarX;
        chart.exporting.menu = new am4core.ExportMenu();
        chart.exporting.filePrefix = "App Usage";
        chart.legend = new am4charts.Legend();

        chart.data = this.state.graph_data.map(datum => {
            return {
                date: new Date(datum.time * 1000),
                name: "",
                community: datum.community,
                system: datum.system,
                web: datum.web
            };
        });

        this.chart = chart;
        this.setState({loaded: true});
    };

    render() {
        let f = Render.rawOverlay(<div style={{
            height: "calc(100vh - 140px)",
            width: "calc((100vh - 140px) / 9 * 16)",
            background: "white",
            border: "4px solid " + window.primary,
            borderRadius: 16,
            display: "flex",
            flexDirection: "column",
            position: "relative",
            overflow: "hidden"
        }}>

            <div style={{height: "100%", display: "flex", flexDirection: "column"}}>
                <div style={{display: "flex", padding: "0px 16px", alignItems: "center"}} className="vl-theme">
                    <h2 style={{flex: 1}}>{!this.state.loaded ? "Loading..." : "Camera Views"}</h2>
                    <i style={{fontSize: 36}} className="material-icons hoverable"
                       onClick={() => this.props.close()}>clear</i>
                </div>
                {!this.state.loaded &&
                <div style={{flex: 1, width: "100%", display: "flex", alignItems: "center", justifyContent: "center"}}>
                    <CircularProgress style={{}} size={100} thickness={2}/>
                </div>
                }

                <div ref={this.graphRef} style={{flex: this.state.loaded ? 1 : 0}}/>
            </div>

        </div>);


        let s = Render.rawOverlay(<div style={{height: "100vh", width: "100vw", background: "rgba(0,0,0,0.7)"}}/>);
        return [s, f];
    };


}